import Nav from "../../general/nav.jsx";
import HeroFooter from "../../general/heroFooter.jsx";
import Imghero from "../../../assets/img/projects/Genome/Genome-hero.png";
import ImgheroMobile from "../../../assets/img/projects/Genome/Genome-hero-mobile.png";
import { useTranslation } from "react-i18next";
import { useState, useLayoutEffect } from "react";

function Hero() {
  const { t } = useTranslation();
  const [isMobile, setIsMobile] = useState(false);

  useLayoutEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const heroStyle = {
    backgroundImage: `url(${isMobile ? ImgheroMobile : Imghero})`,
  };

  return (
    <div className="Genome hero" style={heroStyle}>
      <Nav />
      <HeroFooter
        name={t("genome.hero.name")}
        link1url=""
        link1display={false}
        link2display={false}
        link2name={t("genome.hero.link2")}
        link2url=""
      />
    </div>
  );
}

export default Hero;
